import { Alerta, Badge, Button, DataList, Dialog, Row, Spinner, Stack, TextField } from "@/components";
import type { Rubro } from "@/lib/api";
import { useRubrosTab } from "./useRubrosTab";

export function RubrosTab() {
  const t = useRubrosTab();
  const d = t.dialogo;

  const columnas = [
    { clave: "nombre", titulo: "Rubro", render: (r: Rubro) => r.nombre },
    { clave: "estado", titulo: "Estado", render: (r: Rubro) => (r.activo ? null : <Badge>Archivado</Badge>) },
  ];

  const acciones = (r: Rubro) => (
    <>
      <Button variante="secundario" tamanio="sm" aria-label={`Renombrar ${r.nombre}`} onClick={() => t.abrirRenombrar(r)}>
        Renombrar
      </Button>
      <Button
        variante="secundario"
        tamanio="sm"
        aria-label={`${r.activo ? "Archivar" : "Reactivar"} ${r.nombre}`}
        onClick={() => void t.cambiarEstado(r)}
      >
        {r.activo ? "Archivar" : "Reactivar"}
      </Button>
      <Button variante="fantasma" tamanio="sm" aria-label={`Borrar ${r.nombre}`} onClick={() => t.abrirBorrar(r)}>
        Borrar
      </Button>
    </>
  );

  return (
    <Stack espacio={6}>
      <Row justificar="entre" envolver espacio={3}>
        <h1 className="text-pantalla font-light tracking-[-0.03em]">Rubros</h1>
        <Button onClick={t.abrirNuevo}>Nuevo rubro</Button>
      </Row>
      <p className="text-chico text-texto-suave">
        Un rubro archivado no se ofrece en los gastos nuevos, pero sigue apareciendo en los que ya se cargaron.
      </p>
      {t.aviso && (
        <p role="status" className="rounded-control bg-exito-suave px-3 py-2 text-chico text-exito">
          {t.aviso}
        </p>
      )}
      <Alerta texto={t.errorEstado} />
      {t.cargando && (
        <div className="grid place-items-center py-10 text-primario">
          <Spinner />
        </div>
      )}
      {t.errorCarga && (
        <Stack espacio={3}>
          <Alerta texto={t.errorCarga} />
          <div>
            <Button variante="secundario" onClick={t.reintentar}>
              Reintentar
            </Button>
          </div>
        </Stack>
      )}
      {!t.cargando && !t.errorCarga && (
        <DataList etiqueta="Rubros" columnas={columnas} filas={t.rubros} claveFila={(r) => r.id} acciones={acciones} vacio="Todavía no hay rubros." />
      )}

      <Dialog abierto={d?.tipo === "form"} onCambio={(abierto) => !abierto && t.cerrar()} titulo={d?.tipo === "form" && d.rubro ? "Renombrar rubro" : "Nuevo rubro"}>
        <form onSubmit={(e) => void t.guardar(e)} noValidate>
          <Stack espacio={4}>
            <TextField etiqueta="Nombre" value={t.nombre} onChange={(e) => t.setNombre(e.target.value)} error={t.errorNombre} />
            <Alerta texto={t.errorGuardar} />
            <Row justificar="fin" espacio={2}>
              <Button variante="secundario" onClick={t.cerrar}>
                Cancelar
              </Button>
              <Button type="submit" cargando={t.guardando}>
                Guardar
              </Button>
            </Row>
          </Stack>
        </form>
      </Dialog>

      <Dialog abierto={d?.tipo === "borrar"} onCambio={(abierto) => !abierto && t.cerrar()} titulo="Borrar rubro">
        {d?.tipo === "borrar" && (
          <Stack espacio={4}>
            <p>¿Borrar {d.rubro.nombre}? Si ya se usó en gastos, en vez de borrarse queda archivado.</p>
            <Alerta texto={t.errorBorrar} />
            <Row justificar="fin" espacio={2}>
              <Button variante="secundario" onClick={t.cerrar}>
                Cancelar
              </Button>
              <Button variante="peligro" cargando={t.borrando} onClick={() => void t.confirmarBorrar()}>
                Borrar
              </Button>
            </Row>
          </Stack>
        )}
      </Dialog>
    </Stack>
  );
}
